(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const root = document.body.dataset.root || '/';
  const url = p => `${root}${p}`;
  const i18n = JSON.parse($('#c1-line-i18n')?.textContent || '{}');
  const text = (group, key, fallback = key) => i18n[group]?.[key] || fallback;
  const money = cents => `₱${new Intl.NumberFormat('en-PH', {maximumFractionDigits: 0}).format(Number(cents) / 100)}`;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  // Buying-flow progress (Oct 21): the green fill in each pinned bar, on the one 0–100 scale described in snippets/c1-flow-progress.liquid.
  const setFlowProgress = (bar, value) => {
    const now = String(Math.round(Math.min(100, Math.max(0, value))));
    if (!bar || bar.getAttribute('aria-valuenow') === now) return;
    bar.setAttribute('aria-valuenow', now);
    bar.style.setProperty('--c1-flow-progress', String(Number(now) / 100));
  };
  // A bar that opens with a sheet (the cart, Delivery details) starts from the bar of the screen beneath it and fills forward from there.
  // Returns false while the bar is not shown yet.
  const carryFlowProgress = bar => {
    if (!bar?.getClientRects().length) return false;
    const target = Number(bar.getAttribute('aria-valuenow'));
    const beneath = Math.max(-1, ...$$('[data-c1-flow-progress]').filter(other => other !== bar && other.getClientRects().length).map(other => Number(other.getAttribute('aria-valuenow'))));
    if (beneath >= 0 && beneath < target) {
      bar.dataset.instant = '';
      bar.style.setProperty('--c1-flow-progress', String(beneath / 100));
      bar.getBoundingClientRect();
      delete bar.dataset.instant;
      bar.style.setProperty('--c1-flow-progress', String(target / 100));
    }
    return true;
  };
  let cartState, cartBusy = false, cartPending, productAddPending, noteTimer, notePending, noteDirty = false, checkoutPending = false, cartViewVersion = 0, cartMutated = false, attributionWrite;
  const cartPage = $('[data-cart-page]');
  if (cartPage) {
    const dialog = $('#c1-cart');
    if (dialog) {
      cartPage.replaceChildren(...[...dialog.children].filter(child => !child.classList.contains('c1-dialog-head')));
      dialog.remove();
    }
  }
  const request = async (path, options = {}) => {
    // Item changes close the attribution window and wait for a write already in flight (never start one).
    if (/^cart\/(add|change)\.js$/.test(path)) { cartMutated = true; if (attributionWrite) await attributionWrite; }
    const response = await fetch(url(path), {...options, credentials: 'same-origin'});
    const result = await response.json();
    if (!response.ok) {
      const error = new Error(result.description || result.message || text('product', 'error'));
      error.confirmedFailure = response.status >= 400 && response.status < 500;
      throw error;
    }
    return result;
  };
  const show = id => {
    const dialog = document.getElementById(id);
    if (dialog && !dialog.open) dialog.showModal();
  };
  $$('[data-dialog-open]').forEach(button => button.addEventListener('click', () => show(button.dataset.dialogOpen)));
  $$('[data-dialog-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
  $$('dialog').forEach(dialog => dialog.addEventListener('click', e => {
    if (e.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) dialog.close();
  }));
  $$('#c1-menu a').forEach(a => a.addEventListener('click', () => $('#c1-menu').close()));
  const bar = $('[data-christmas]');
  const everydayBarCopy = bar ? $('[data-christmas-copy]',bar).textContent : '';
  function refreshChristmas(now = new Date()) {
    if (!bar) return;
    const today = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Manila',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
    const valid = /^\d{4}-\d{2}-\d{2}$/.test(bar.dataset.lastDate || '') && !Number.isNaN(Date.parse(`${bar.dataset.lastDate}T23:59:59+08:00`));
    const active = bar.dataset.enabled === 'true' && valid && today <= bar.dataset.lastDate && !!bar.dataset.provinces && !!bar.dataset.metro;
    bar.dataset.active = String(active);
    $('[data-christmas-copy]', bar).textContent = active ? `Christmas cutoffs · Provinces ${bar.dataset.provinces} · Metro Manila ${bar.dataset.metro} · Made in 1–2 days, then shipped` : everydayBarCopy;
    $$('[data-holiday-line]').forEach(line => {
      line.hidden = !active;
      const dest = $('span', line) || line;
      dest.textContent = active ? `For Christmas, ${line.closest('#c1-cart') ? 'check out' : 'order'} by ${bar.dataset.provinces} (provinces) or ${bar.dataset.metro} (Metro Manila).` : '';
    });
  }
  refreshChristmas();
  document.addEventListener('visibilitychange', () => refreshChristmas());
  window.addEventListener('pageshow', () => refreshChristmas());
  setInterval(refreshChristmas, 60000);
  const making = $('[data-making-chips]');
  if (making) {
    const sync = () => { $('[data-making-value]').value = $$('input:checked', making).map(x => x.value).join(', '); };
    making.addEventListener('change', sync);
    $('#c1-team-quote').addEventListener('submit', sync);
  }
  $$('[data-recipient]').forEach(button => button.addEventListener('click', () => {
    $$('[data-recipient]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
    $$('[data-recipient-panel]').forEach(x => { x.hidden = x.dataset.recipientPanel !== button.dataset.recipient; });
  }));
  const shop = $('[data-shop-grid]');
  if (shop) {
    const cards = $$('[data-product-card]', shop);
    cards.forEach((card, index) => { card.dataset.originalIndex = index; });
    let kind = 'all', recipientIDs = [];
    const filter = () => {
      const min = Number($('[data-price-min]')?.value || 0) * 100;
      const maxVal = $('[data-price-max]')?.value;
      const max = maxVal === '' || maxVal === undefined ? Infinity : Number(maxVal) * 100;
      cards.forEach(c => { c.hidden = !(kind === 'all' || c.dataset.kind === kind || (kind === 'chibi' && c.dataset.kind === 'graduation')) || (recipientIDs.length && !recipientIDs.includes(c.dataset.productId)) || Number(c.dataset.price) < min || Number(c.dataset.price) > max; });
      $('[data-no-results]').hidden = cards.some(c => !c.hidden);
      const sort = $('[data-sort]').value;
      const ordered = [...cards].sort((a, b) => sort === 'price-ascending' ? Number(a.dataset.price) - Number(b.dataset.price) : sort === 'created-descending' ? Number(b.dataset.created) - Number(a.dataset.created) : Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
      const tile = $('.c1-shop-teams', shop);
      ordered.forEach(card => shop.insertBefore(card, tile));
      const visible = ordered.filter(c => !c.hidden);
      if (matchMedia('(max-width: 989px)').matches && visible.length > 6) shop.insertBefore(tile, visible[6]);
    };
    $$('[data-type]').forEach(button => button.addEventListener('click', () => {
      kind = button.dataset.type;
      $$('[data-type]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
      filter();
    }));
    $('[data-sort]').addEventListener('change', filter);
    $$('[data-shop-recipient]').forEach(button => button.addEventListener('click', () => {
      recipientIDs = JSON.parse(button.dataset.shopRecipient).map(String);
      $$('[data-shop-recipient]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
      filter();
    }));
    $$('[data-price-min],[data-price-max]').forEach(input => input.addEventListener('input', filter));
    filter();
  }
  // Grip Tok lines carry the design as JSON in _c1_grip_design. The product has no photos, so the cart draws the name in the letter color on the
  // base color, and names the style as the preview does (Name shape / Circle), including orders made before the variant rename.
  // Missing or unreadable data falls back to the plain line; an unknown color id falls back to mist (base) or ink (letters).
  // Screen colors of the Grip Tok filaments, same ids and values as GripTokColorways in sections/c1-grip-tok-customer.liquid. That script only runs
  // on the Grip Tok product page, so /cart and the cart sheet on every other page use this copy.
  const GRIP_HEX = {'esun-matcha-green':'#A3B875','esun-soft-pink':'#EFB6C8','esun-purple':'#7954A7','esun-almond-yellow':'#F3DEA0','esun-light-brown':'#B58B69','esun-milky-white':'#F6F1E7','esun-black':'#202124','esun-lilac':'#B6A2D6','esun-soft-blue':'#A9CCDF','esun-brown':'#72503E','maroon':'#762D41','butter':'#EDE894','blush':'#F0B8CC','rust':'#AB4D26','navy':'#15384E','olive':'#BCC967','lilac':'#B6A2D6','carbon-black':'#202124','warm-white':'#FFF7D6','window-blue':'#BFE9FF','electric-blue':'#4361EE','c1-pink':'#FF6B9D'};
  const gripHex = (id, fallback) => { const hex = window.GripTokColorways?.getFilament?.(id)?.hex || (Object.hasOwn(GRIP_HEX, id) ? GRIP_HEX[id] : ''); return /^#[0-9a-f]{6}$/i.test(hex) ? hex : fallback; };
  const gripDesign = item => {
    try {
      const config = JSON.parse(item.properties?._c1_grip_design || 'null');
      if (!config || typeof config.text !== 'string' || !config.text.trim()) return null;
      return { lines: config.text.split('\n').slice(0, 2), style: config.engineVersion === 4 ? 'Circle' : 'Name shape', base: gripHex(config.baseColor, '#F3F3F1'), letters: gripHex(config.textColor, '#0B0B0C') };
    } catch { return null; }
  };
  const gripThumb = grip => {
    const longest = Math.max(...grip.lines.map(line => line.length));
    const size = Math.max(9, Math.min(20, Math.floor(58 / (longest * 0.62))));
    const text = grip.lines.map((line, index) => `<text x="42" y="${42 + (index - (grip.lines.length - 1) / 2) * size * 1.15}" text-anchor="middle" dominant-baseline="central" font-family="Figtree, system-ui, sans-serif" font-weight="800" font-size="${size}" fill="${grip.letters}"${longest * size * 0.62 > 58 ? ' textLength="58" lengthAdjust="spacingAndGlyphs"' : ''}>${esc(line)}</text>`).join('');
    return `<svg class="c1-cart-grip" role="img" aria-label="${esc(grip.lines.join(' '))} · ${esc(grip.style)}" viewBox="0 0 84 84" width="84" height="84"><rect width="84" height="84" rx="14" fill="#F3F3F1"/><circle cx="42" cy="42" r="35" fill="${grip.base}" stroke="#0B0B0C" stroke-opacity=".12"/>${text}</svg>`;
  };
  // Compare-at prices are not on cart.js. The cart snippet seeds variant cents, and an add on this page records the variant just added.
  const compareAtByVariant = {};
  const rememberCompare = (id, cents) => {
    if (id == null || id === '') return;
    const amount = Number(cents);
    if (amount > 0) compareAtByVariant[String(id)] = amount;
    else delete compareAtByVariant[String(id)];
  };
  const seedCompareAt = () => {
    try {
      const raw = JSON.parse($('#c1-compare-at')?.textContent || '{}');
      if (raw && typeof raw === 'object') Object.entries(raw).forEach(([id, cents]) => rememberCompare(id, cents));
    } catch {}
  };
  seedCompareAt();
  const lineCompareCents = item => {
    const qty = Math.max(1, Number(item?.quantity) || 1);
    const paid = Number(item?.final_line_price);
    const unit = Number(item?.compare_at_price) || Number(compareAtByVariant[String(item?.variant_id)]) || 0;
    const line = unit * qty;
    return Number.isFinite(paid) && line > paid ? line : 0;
  };
  const salePriceHtml = item => {
    const compare = lineCompareCents(item);
    const struck = compare ? `<del>${money(compare)}</del><span class="c1-sale">${esc(text('cart', 'sale', 'Sale'))}</span>` : '';
    return `<p class="c1-cart-price"><strong>${money(item.final_line_price)}</strong>${struck}</p>`;
  };
  function renderCart(cart) {
    cartViewVersion++;
    cartState = cart;
    $$('[data-cart-count]').forEach(span => { span.textContent = cart.item_count; span.hidden = !cart.item_count; });
    $('[data-cart-summary]').hidden = !cart.item_count;
    $$('#c1-cart [data-c1-flow],[data-cart-page] [data-c1-flow]').forEach(flow => { flow.hidden = !cart.item_count; });
    const items = $('[data-cart-items]');
    if (!cart.items.length) { items.innerHTML = '<p>Your cart is empty.</p><a class="c1-link" href="'+url('collections/all')+'">Shop all</a>'; return; }
    items.innerHTML = cart.items.map(item => {
      const grip = gripDesign(item);
      const variant = grip ? grip.style : item.variant_title === 'Default Title' ? '' : item.variant_title || '';
      const props = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value !== '').map(([key, value]) => {
        if(key!=='Photo')return `<p>${esc(key)}: ${esc(value)}</p>`;
        let filename='';try{filename=decodeURIComponent(new URL(value,location.origin).pathname.split('/').at(-1));}catch{}
        return `<p>${esc(text('cart','photo'))}${filename?' · '+esc(filename):''}</p>`;
      }).join('');
      return `<article class="c1-cart-item">${grip ? gripThumb(grip) : item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="84" height="84">` : '<div></div>'}<div><h3>${esc(item.product_title)}</h3><p class="c1-typed">${esc(variant)}</p>${salePriceHtml(item)}${props}<div class="c1-row"><div class="c1-qty"><button aria-label="Fewer" data-cart-change="${esc(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button aria-label="More" data-cart-change="${esc(item.key)}" data-quantity="${item.quantity+1}">+</button></div><button class="c1-link" data-cart-change="${esc(item.key)}" data-quantity="0">${esc(text('cart','remove'))}</button></div></div></article>`;
    }).join('');
    $$('[data-cart-subtotal]').forEach(x => { x.textContent = money(cart.total_price); });
    const note = $('[data-cart-note]');
    if (document.activeElement !== note && !noteDirty && !noteTimer && !notePending) note.value = cart.note || '';
    $$('[data-cart-change]').forEach(button => button.addEventListener('click', async () => {
      if (cartBusy || checkoutPending) return;
      cartBusy = true;
      $$('[data-cart-change]').forEach(x => { x.disabled = true; });
      cartPending = request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.cartChange,quantity:Number(button.dataset.quantity)})});
      try { renderCart(await cartPending); }
      catch (error) { $('[data-cart-error]').textContent = error.message; $('[data-cart-error]').hidden = false; }
      finally { cartBusy = false; cartPending = undefined; $$('[data-cart-change]').forEach(x => { x.disabled = false; }); }
    }));
  }
  async function refreshCart() {
    const version = ++cartViewVersion;
    try {
      const cart = await request('cart.js');
      if (version === cartViewVersion) renderCart(cart);
    } catch (error) { if (version === cartViewVersion) throw error; }
  }
  async function openCart(event) {
    event?.preventDefault();
    show('c1-cart');
    // The cart's fill (50) grows from the product page's; a cart that was empty until now shows its bar after the cart loads.
    const flowBar = $('#c1-cart [data-c1-flow-progress],[data-cart-page] [data-c1-flow-progress]'), carried = carryFlowProgress(flowBar);
    $('[data-cart-items]').textContent = 'Loading…';
    $('[data-cart-error]').hidden = true;
    try { await refreshCart(); if (!carried) carryFlowProgress(flowBar); }
    catch (error) { $('[data-cart-items]').textContent = ''; $('[data-cart-error]').textContent = error.message; $('[data-cart-error]').hidden = false; }
  }
  $$('[data-cart-open]').forEach(a => a.addEventListener('click', openCart));
  document.addEventListener('grip-tok:cart-added',async()=>{try{await refreshCart();}catch{}});
  const saveNote = async () => {
    clearTimeout(noteTimer); noteTimer = undefined;
    if (notePending) {
      await notePending;
      if (noteDirty) return saveNote();
      return;
    }
    if (!noteDirty) return;
    const note = $('[data-cart-note]').value;
    const pending = request('cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})});
    notePending = pending;
    try {
      await pending;
      if ($('[data-cart-note]').value === note && notePending === pending) {
        noteDirty = false;
        $('[data-note-status]').textContent = text('cart','note_saved');
      }
    }
    catch (error) { $('[data-cart-error]').textContent = error.message; $('[data-cart-error]').hidden = false; throw error; }
    finally { if (notePending === pending) notePending = undefined; }
  };
  $('[data-cart-note]')?.addEventListener('input', () => { noteDirty = true; $('[data-note-status]').textContent = ''; clearTimeout(noteTimer); noteTimer = setTimeout(() => saveNote().catch(() => {}), 600); });
  const goToCheckout = async (checkoutURL = url('checkout'), confirmedProductAdd = false, cartReady, summary) => {
    if (checkoutPending) return false;
    checkoutPending = true;
    try {
      if (!window.C1Delivery) throw new Error('Delivery details could not load. Please refresh the page.');
      // A cart/header checkout opened after cancelling delivery must inherit
      // any still-running product add, including an ambiguous outcome hold.
      const pendingProductAdd = productAddPending;
      const prepareCart = async () => {
        if (cartReady) await cartReady;
        if (pendingProductAdd && pendingProductAdd !== cartReady) await pendingProductAdd;
        if (cartPending) { await cartPending; confirmedProductAdd = false; }
        while (noteDirty || noteTimer || notePending) {
          if (notePending) await notePending;
          else await saveNote();
        }
        // The quote and prepare paths also verify the current full cart.
        if (!confirmedProductAdd) {
          const cart = await request('cart.js');
          renderCart(cart);
          if (!cart.item_count) throw new Error('Your cart is empty.');
        }
      };
      let accepted;
      if ((cartReady || pendingProductAdd) && window.C1Delivery.cartReadyVersion === 1) {
        // Only a versioned delivery form can display before mutation finishes.
        // The promise is a gate, never a signal to repeat the add request.
        const ready = prepareCart();
        ready.catch(() => {});
        accepted = await window.C1Delivery.open({ checkoutURL, cartReady: ready, ...(summary && { summary }) });
      } else {
        await prepareCart();
        accepted = await window.C1Delivery.open({ checkoutURL, ...(summary && { summary }) });
      }
      return Boolean(accepted);
    }
    finally { checkoutPending = false; }
  };
  $('.c1-cart-checkout')?.addEventListener('click', async event => {
    event.preventDefault();
    try { await goToCheckout(event.currentTarget.href); }
    catch (error) { $('[data-cart-error]').textContent = error.message; $('[data-cart-error]').hidden = false; }
  });
  if (cartPage) openCart();
  // Step bar and progress fill in Delivery details (current step: Checkout). c1-delivery.js builds that dialog on its first open (appended to
  // body, also from the Grip Tok Buy now), so copy them from their templates as soon as the dialog exists: the step bar under the title row,
  // the fill on the line above the total. Neither is added if that markup changes.
  const deliveryFlow = $('#c1-flow-checkout'), deliveryProgress = $('#c1-flow-progress-checkout');
  // The fill is 50 (a design is in the cart), plus an equal share of 45 for each completed required detail (the optional landmark doesn't
  // count) and the last 5 once the shipping total shows. c1-delivery.js also fills fields itself (saved details, the town lists, a suggested
  // ZIP), so any change in the sheet recounts, once per frame.
  const watchDeliveryProgress = dialog => {
    const actions = $('.c1-delivery__actions', dialog);
    if (!deliveryProgress || !actions || $('[data-c1-flow-progress]', dialog)) return;
    actions.prepend(deliveryProgress.content.cloneNode(true));
    const bar = $('[data-c1-flow-progress]', actions);
    let frame = 0;
    const count = () => {
      frame = 0;
      const fields = $$('.c1-delivery__fields input[required],.c1-delivery__fields select[required]', dialog);
      const done = fields.filter(field => field.value.trim() && field.validity.valid && field.getAttribute('aria-invalid') !== 'true').length;
      setFlowProgress(bar, 50 + (fields.length ? 45 * done / fields.length : 0) + ($('.c1-delivery__shipping', dialog)?.hidden === false ? 5 : 0));
    };
    const recount = () => { if (!frame) frame = requestAnimationFrame(count); };
    dialog.addEventListener('input', recount);
    dialog.addEventListener('change', recount);
    new MutationObserver(recount).observe(dialog, {subtree: true, childList: true, characterData: true, attributeFilter: ['hidden', 'disabled', 'aria-invalid']});
    new MutationObserver(() => { if (dialog.open) { count(); carryFlowProgress(bar); } }).observe(dialog, {attributeFilter: ['open']});
    count();
    if (dialog.open) carryFlowProgress(bar);
  };
  if (deliveryFlow || deliveryProgress) {
    const addDeliveryFlow = () => {
      const dialog = document.getElementById('c1-delivery-dialog');
      if (!dialog) return false;
      if (deliveryFlow && !$('[data-c1-flow]', dialog)) $('.c1-delivery__header', dialog)?.after(deliveryFlow.content.cloneNode(true));
      watchDeliveryProgress(dialog);
      return true;
    };
    if (!addDeliveryFlow()) {
      const watch = new MutationObserver(() => { if (addDeliveryFlow()) watch.disconnect(); });
      watch.observe(document.body, {childList: true});
    }
  }
  // Ad attribution: utm_* and fbclid from the landing URL are kept for 30 days
  // (last touch) and copied into private cart attributes, which the checkout
  // server copies onto the draft order. The checkout quote fingerprints the
  // whole cart, so this writes only at idle, before any item change in this
  // page view, never during checkout, and only when the cart's values differ.
  const attributionFields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  const readAttribution = () => {
    try {
      const saved = JSON.parse(localStorage.getItem('c1-attribution') || 'null');
      return saved?.attributes && Date.now() - saved.at < 30 * 864e5 ? saved : null;
    } catch { return null; }
  };
  const landing = new URLSearchParams(location.search);
  if (attributionFields.some(key => landing.get(key))) {
    const clean = value => String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 500);
    const previous = readAttribution()?.attributes, attributes = {};
    attributionFields.forEach(key => { attributes[`_${key}`] = clean(landing.get(key)); });
    // Reloading the same ad link keeps its first click time and landing page.
    if (!previous || attributionFields.some(key => previous[`_${key}`] !== attributes[`_${key}`])) {
      attributes._fbc = attributes._fbclid ? `fb.1.${Date.now()}.${attributes._fbclid}` : '';
      attributes._landing_path = clean(location.pathname);
      try { localStorage.setItem('c1-attribution', JSON.stringify({ at: Date.now(), attributes })); } catch {}
    }
  }
  const checkoutHeld = () => {
    try {
      for (let index = 0; index < sessionStorage.length; index++) {
        const key = sessionStorage.key(index);
        if (key.startsWith('c1-invoice-checkout-v1:') && JSON.parse(sessionStorage.getItem(key))?.active) return true;
      }
      return false;
    } catch { return true; }
  };
  const attributionBlocked = () => cartMutated || checkoutPending || cartBusy || !!cartPending || noteDirty || !!noteTimer || !!notePending || !!$('dialog[open]') || checkoutHeld();
  const syncAttribution = async () => {
    const saved = readAttribution(), signature = JSON.stringify(saved);
    if (!saved || attributionBlocked()) return;
    try { if (sessionStorage.getItem('c1-attribution-synced') === signature) return; } catch {}
    const cart = await request('cart.js', { priority: 'low' });
    if (attributionBlocked()) return;
    // Only differing keys are sent; an empty value clears an older touch's key and is never added new.
    const changes = Object.fromEntries(Object.entries(saved.attributes).filter(([key, value]) => (cart.attributes?.[key] || '') !== value));
    if (Object.keys(changes).length) {
      // Shares the gift-note gate, so every checkout entry waits for this write.
      const write = request('cart/update.js', { method: 'POST', priority: 'low', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: changes }) })
        .then(() => true, () => false)
        .then(ok => { if (notePending === write) notePending = undefined; attributionWrite = undefined; return ok; });
      attributionWrite = notePending = write;
      if (!await write) return;
    }
    try { sessionStorage.setItem('c1-attribution-synced', signature); } catch {}
  };
  document.addEventListener('grip-tok:cart-added', () => { cartMutated = true; });
  const startAttribution = () => { syncAttribution().catch(() => {}); };
  if (window.requestIdleCallback) requestIdleCallback(startAttribution, { timeout: 3000 }); else setTimeout(startAttribution, 1500);
  const panel = $('[data-personalizer]');
  if (!panel) return;
  const form = $('form', panel);
  const q = selector => $(selector, panel);
  const qa = selector => $$(selector, panel);
  const source = JSON.parse($('[data-personalizer-data]', panel).textContent);
  const products = source.products.filter(x => x.product?.id);
  let entry = products.find(x => x.product.handle === source.current);
  if (!entry) return;
  const state = {wood:entry.meta.wood,shape:entry.meta.shape,engraving:'both',people:'small',names:'with',qty:1,file:undefined,objectURL:'',sending:false,unknown:false,added:false,previewVariant:false};
  const qs = new URLSearchParams(location.search);
  if (['text','photo','both'].includes(qs.get('engraving'))) state.engraving = qs.get('engraving');
  let selected;
  const woodVariant = (p, mode) => p.variants.find(v => mode === 'both' ? /text.*image|image.*text/i.test(v.title) : mode === 'text' ? /text only/i.test(v.title) : /image only/i.test(v.title));
  const cleanImages = p => (p.images || []).map(x => typeof x === 'string' ? x : x.src).filter(x => x && !x.split('?')[0].endsWith(entry.meta.guide_filename));
  const photoName = src => String(src || '').split('?')[0].split('/').pop();
  let galleryKey = null;
  const gallery = () => {
    const images = cleanImages(entry.product);
    const choiceFile = entry.meta.kind === 'wood' && state.previewVariant ? entry.meta.variant_files[['text','photo','both'].indexOf(state.engraving)] : '';
    const main = choiceFile ? images.find(x => x.split('?')[0].endsWith(choiceFile)) : undefined;
    const ordered = main ? [main,...images.filter(x => x !== main)] : images;
    // Same photos in the same order (the server render, or the live product
    // refresh from cdn.shopify.com): keep the loaded images, never re-request them.
    const key = ordered.map(photoName).join('|');
    if (key === galleryKey) return;
    // Phones draw the square photo inside a 3:2 box, (100vw - 32px) wide.
    if (galleryKey !== null || key !== $$('img', q('[data-gallery]')).map(img => photoName(img.getAttribute('src'))).join('|')) q('[data-gallery]').innerHTML = ordered.map((src,index) => `<img class="c1-photo" src="${esc(src)}${src.includes('?') ? '&' : '?'}width=1080" srcset="${esc(src)}${src.includes('?')?'&':'?'}width=360 360w, ${esc(src)}${src.includes('?')?'&':'?'}width=720 720w, ${esc(src)}${src.includes('?')?'&':'?'}width=1080 1080w" sizes="(min-width:990px) 580px,calc((100vw - 32px) * 2 / 3)" alt="${esc(entry.meta.title)}" loading="${index ? 'lazy':'eager'}"${index ? '' : ' fetchpriority="high"'} width="1080" height="1080">`).join('');
    galleryKey = key;
    q('[data-gallery-dots]').innerHTML = `<div class="c1-gallery-markers" aria-hidden="true">${ordered.map((_,index) => `<span class="c1-gallery-dot" data-marker="${index}" data-active="${index===0}"></span>`).join('')}</div><span class="c1-gallery-position c1-typed" data-gallery-position>1 / ${ordered.length}</span><div class="c1-gallery-thumbnails">${ordered.map((src,index) => `<button type="button" aria-label="Photo ${index+1}" aria-pressed="${index===0}" data-gallery-index="${index}"><img src="${esc(src)}${src.includes('?')?'&':'?'}width=180" alt="" width="120" height="120" loading="lazy"></button>`).join('')}</div>`;
    q('[data-gallery]').tabIndex=0;
    q('[data-gallery]').setAttribute('aria-label','Product photos. Use left and right arrow keys to move between photos.');
    qa('[data-gallery-index]').forEach(button => button.addEventListener('click', () => {
      q('[data-gallery]').scrollTo({left:Number(button.dataset.galleryIndex) * (q('[data-gallery]').clientWidth+16),behavior:'smooth'});
      qa('[data-gallery-index]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
    }));
  };
  q('[data-gallery]').addEventListener('scroll',()=>{
    const index=Math.round(q('[data-gallery]').scrollLeft/(q('[data-gallery]').clientWidth+16));
    qa('[data-marker]').forEach(x=>{x.dataset.active=String(Number(x.dataset.marker)===index);});
    qa('[data-gallery-index]').forEach(x=>x.setAttribute('aria-pressed',String(Number(x.dataset.galleryIndex)===index)));
    q('[data-gallery-position]').textContent=`${index+1} / ${q('[data-gallery]').children.length}`;
  });
  q('[data-gallery]').addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();
    const step=q('[data-gallery]').clientWidth+16;
    const index=Math.round(q('[data-gallery]').scrollLeft/step);
    const next=Math.max(0,Math.min(q('[data-gallery]').children.length-1,index+(event.key==='ArrowRight'?1:-1)));
    q('[data-gallery]').scrollTo({left:next*step,behavior:'smooth'});
  });
  const engravingMeasure = document.createElement('canvas').getContext('2d');
  const fitEngravedWords = () => {
    if (entry.meta.kind !== 'wood') return;
    const preview = q('[data-engraved-words]');
    const plate = preview.closest('[data-plate]');
    const plateWidth = plate.clientWidth || (state.shape === 'rectangle' ? 92 : state.shape === 'square' ? 124 : 128);
    const plateHeight = plate.clientHeight || (state.shape === 'rectangle' ? 150 : state.shape === 'square' ? 124 : 128);
    const availableWidth = plateWidth - 24;
    const length = [...preview.textContent].length;
    const preferredSize = length <= 6 ? 26 : length <= 10 ? 22 : length <= 16 ? 18 : 15;
    const font = getComputedStyle(preview);
    let longestWidth = 0;
    if (engravingMeasure) {
      engravingMeasure.font = `${font.fontStyle} ${font.fontWeight} ${preferredSize}px ${font.fontFamily}`;
      longestWidth = Math.max(0, ...preview.textContent.split(/\s+/).map(word => engravingMeasure.measureText(word).width));
    }
    let size = Math.max(8, Math.min(preferredSize, longestWidth ? Math.floor(preferredSize * availableWidth * .94 / longestWidth * 2) / 2 : preferredSize));
    preview.style.fontSize = `${size}px`;
    while (size > 8 && preview.scrollHeight > plateHeight - 24) {
      size -= .5;
      preview.style.fontSize = `${size}px`;
    }
  };
  const nextMissing = () => {
    const kind = entry.meta.kind;
    if (!q('[data-photo-step]').hidden && !q('[data-photo]').files.length) return {field: q('[data-photo]'), key: 'next_photo'};
    if (!q('[data-words-step]').hidden && !q('[data-words]').value.trim()) return {field: q('[data-words]'), key: kind === 'chibi' ? 'next_names' : kind === 'graduation' ? 'next_name' : 'next_words'};
    const course = q('[data-course]');
    if (course && !course.value.trim()) return {field: course, key: 'next_course'};
    return null;
  };
  const update = (changeGallery = false) => {
    const kind = entry.meta.kind;
    const photoNeeded = kind !== 'wood' || state.engraving !== 'text';
    const wordsNeeded = kind === 'wood' ? state.engraving !== 'photo' : kind === 'chibi' ? state.names === 'with' : kind === 'graduation';
    selected = kind === 'wood' ? woodVariant(entry.product,state.engraving) : kind === 'chibi' ? entry.product.variants.find(v => (state.people === 'large' ? /3\+/.test(v.title) : /1.?2/.test(v.title)) && (state.names === 'without' ? /without/.test(v.title) : /with name/.test(v.title))) : kind === 'graduation' ? entry.product.variants.find(v => String(v.id) === q('[data-grad-variant]').value) : entry.product.variants[0];
    q('[data-variant-id]').value = selected?.id || '';
    q('[data-unit-price]').textContent = money(selected?.price || 0);
    const compareHigher = selected?.compare_at_price > selected?.price;
    const onSale = selected?.available !== false && compareHigher;
    q('[data-compare-price]').textContent = money(selected?.compare_at_price || 0);
    q('[data-compare-price]').hidden = !compareHigher;
    const saleBadge = q('[data-sale-badge]');
    if (saleBadge) saleBadge.hidden = !onSale;
    q('[data-total-price]').textContent = money((selected?.price || 0)*state.qty);
    q('[data-selection-summary]').textContent = kind === 'wood' ? `${state.wood === 'beech' ? 'Beech':'Mahogany'} · ${state.shape} · ${state.engraving === 'both' ? 'both sides' : state.engraving === 'text' ? 'words':'photo'}` : selected?.title === 'Default Title' ? '' : selected?.title || '';
    q('[data-quantity]').value = state.qty;
    q('[data-quantity-display]').textContent = state.qty;
    q('[data-photo-step]').hidden = !photoNeeded;
    q('[data-photo]').disabled = !photoNeeded;
    q('[data-words-step]').hidden = !wordsNeeded;
    const words = q('[data-words]');
    words.disabled = !wordsNeeded;
    words.name = kind === 'chibi' ? 'properties[Names]' : kind === 'graduation' ? 'properties[Name]' : 'properties[Words]';
    q('[data-words-title]').textContent = kind === 'chibi' ? text('product','names') : kind === 'graduation' ? text('product','name') : text('product','words');
    q('[data-words-label]').textContent = kind === 'wood' && state.engraving === 'both' ? text('product','back_words') : kind === 'chibi' ? text('product','names') : kind === 'graduation' ? text('product','name') : text('product','words_label');
    q('[data-words-hint]').hidden = kind !== 'wood';
    const limit = Number(entry.words_limit);
    if (limit > 0) words.maxLength = limit; else words.removeAttribute('maxlength');
    q('[data-words-counter]').textContent = `${[...words.value].length}${limit>0 ? ` / ${limit}` : ''}`;
    q('[data-photo-step-number]').textContent = kind === 'wood' ? 3 : kind === 'chibi' ? 3 : kind === 'graduation' ? 2 : 1;
    q('[data-words-step-number]').textContent = kind === 'wood' ? photoNeeded ? 4 : 3 : kind === 'chibi' ? 4 : 3;
    q('[data-preview-request]').hidden = !entry.preview_allowed;
    q('[data-preview-request] input').disabled = !entry.preview_allowed;
    if (!entry.preview_allowed) q('[data-preview-request] input').checked = false;
    if (kind === 'wood') {
      qa('[data-wood-choice]').forEach(button => {
        const sibling = products.find(x => x.product.handle === button.dataset.woodChoice);
        button.setAttribute('aria-pressed', String(sibling === entry));
        button.setAttribute('aria-disabled', String(!sibling || state.sending));
        if (sibling) {
          button.href = url(`products/${sibling.product.handle}?engraving=${state.engraving}`);
          $('[data-wood-choice-price]', button).textContent = money(woodVariant(sibling.product, state.engraving)?.price || 0);
        }
      });
      qa('input[name=engraving]').forEach(input => { input.checked=input.value===state.engraving; });
      qa('[data-option-price]').forEach(x => { x.textContent=money(woodVariant(entry.product,x.dataset.optionPrice)?.price || 0); });
      q('[data-front-preview]').hidden = !photoNeeded;
      q('[data-back-preview]').hidden = !wordsNeeded;
      qa('[data-plate]').forEach(plate=>{plate.dataset.wood=state.wood;plate.dataset.shape=state.shape;});
      const shown=words.value.trim() || text('product','words_only');
      q('[data-engraved-words]').textContent=shown;
      fitEngravedWords();
    }
    qa('[data-add]').forEach(button => { button.disabled = state.sending || state.unknown || state.added || !selected || selected.available === false; });
    const nextStep = q('[data-next-step]');
    if (nextStep) {
      const missing = nextMissing();
      const unavailable = !selected || selected.available === false;
      const summary = q('[data-selection-summary]').textContent.trim();
      const message = unavailable ? text('product','unavailable') : state.unknown ? text('product','qty') : missing ? text('product', missing.key) : summary ? `${text('product','ready')} · ${summary}` : text('product','ready');
      const ready = unavailable || state.unknown ? 'blocked' : String(!missing);
      if (nextStep.textContent !== message) nextStep.textContent = message;
      nextStep.dataset.ready = ready;
      nextStep.setAttribute('aria-disabled', String(ready !== 'false'));
    }
    // Pinned bar fill: 10 with the default choices, up to 34 as the photo, words and course this keychain needs are added, 50 once it is
    // in the cart.
    const course = q('[data-course]');
    const needs = [[photoNeeded, q('[data-photo]').files.length > 0], [wordsNeeded, !!words.value.trim()], [!!course, !!course?.value.trim()]].filter(([needed]) => needed);
    setFlowProgress(q('[data-c1-flow-progress]'), state.added ? 50 : 10 + 24 * (needs.length ? needs.filter(([, done]) => done).length / needs.length : 1));
    q('[data-product-checkout]').disabled = state.sending || checkoutPending;
    qa('[data-another],[data-edit-line]').forEach(button => { button.disabled = state.sending || checkoutPending; });
    if (changeGallery) gallery();
  };
  const selectSibling = () => {
    const sibling=products.find(x=>x.meta.wood===state.wood&&x.meta.shape===state.shape);
    if (!sibling) return;
    entry=sibling;
    const next=new URL(location.href);
    next.pathname=url(`products/${entry.product.handle}`);
    next.searchParams.set('engraving',state.engraving);
    next.searchParams.delete('variant');
    history.replaceState({},'',next);
    q('[data-product-error]').hidden=true;
    update(true);
    document.dispatchEvent(new CustomEvent('c1:product-change', {detail: {productId: entry.product.id}}));
  };
  qa('[data-wood-choice]').forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    if(state.sending||checkoutPending||button.getAttribute('aria-disabled')==='true')return;
    state.wood=button.dataset.wood;state.shape=button.dataset.shape;state.previewVariant=false;selectSibling();
  }));
  qa('[data-wood-choice]').forEach(button=>button.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();button.click();}}));
  form.addEventListener('change',event=>{
    if (event.target.name==='engraving'){state.engraving=event.target.value;state.previewVariant=true;selectSibling();}
    else if(event.target.name==='people'){state.people=event.target.value;update();}
    else if(event.target.name==='name_option'){state.names=event.target.value;update();}
    else if(event.target.matches('[data-grad-variant]'))update();
  });
  q('[data-words]').addEventListener('input',()=>{q('[data-product-error]').hidden=true;update();});
  q('[data-photo]').addEventListener('change',event=>{
    const file=event.target.files?.[0];
    if(!file){update();return;}
    if(!(/^image\//.test(file.type)||/\.(heic|heif)$/i.test(file.name))){q('[data-product-error]').textContent='Choose a photo file.';q('[data-product-error]').hidden=false;event.target.value='';update();return;}
    if(state.objectURL)URL.revokeObjectURL(state.objectURL);
    state.file=file;state.objectURL=URL.createObjectURL(file);
    const thumbnail=q('[data-photo-thumbnail]');
    thumbnail.src=state.objectURL;thumbnail.hidden=false;
    q('[data-photo-name]').textContent=file.name;
    // No quality check runs here, so stay neutral; a screenshot gets a gentle hint but is still accepted.
    q('[data-photo-status]').textContent=/screenshot/i.test(file.name)?text('product','photo_added_screenshot','Photo added. Screenshots often print blurry; a photo from your camera works best. Tap to change it.'):text('product','photo_added','Photo added. Tap to change it.');
    q('[data-photo-action]').textContent=text('product','change');
    thumbnail.onerror=()=>{thumbnail.hidden=true;q('[data-photo-status]').textContent=text('product','check_file');};
    const engraving=q('[data-engraved-photo]');engraving.src=state.objectURL;engraving.hidden=false;q('[data-photo-preview-copy]').hidden=true;
    engraving.onerror=()=>{engraving.hidden=true;q('[data-photo-preview-copy]').hidden=false;};
    q('[data-product-error]').hidden=true;update();
  });
  q('[data-quantity-down]').addEventListener('click',()=>{state.qty=Math.max(1,state.qty-1);update();});
  q('[data-quantity-up]').addEventListener('click',()=>{state.qty=Math.min(99,state.qty+1);update();});
  const finishCheckout = async (confirmedProductAdd = false, cartReady, summary) => {
    const error = q('[data-product-error]');
    try {
      const continuing = await goToCheckout(undefined, confirmedProductAdd, cartReady, summary);
      if (!continuing && !checkoutPending && !cartReady) await openCart();
    } catch {
      error.textContent = q('[data-checkout-error]').dataset.checkoutError;
      error.hidden = false;
    }
  };
  q('[data-product-checkout]').addEventListener('click', async () => {
    if (!state.added || state.sending || checkoutPending) return;
    state.sending = true; update();
    try { await finishCheckout(); }
    finally { state.sending = false; update(); }
  });
  q('[data-another]').addEventListener('click',()=>{
    if(state.sending||checkoutPending)return;
    // A new keychain starts at 1 (phones hide the stepper; an edit may have kept a cart quantity).
    state.replace=undefined;state.qty=1;q('[data-edit-note]')?.remove();
    q('[data-added]').hidden=true;q('[data-add-controls]').hidden=false;state.added=false;state.unknown=false;update();
  });
  // Edit this keychain: the same choices come back, and the next Buy now or Add to cart REPLACES
  // the line this page added (state.line) instead of adding a second personalized line.
  // "Add another" keeps that line. The delivery summary's Edit leads here too.
  const editLine=()=>{
    if(state.sending||checkoutPending||!state.line)return;
    state.replace=state.line;
    q('[data-added]').hidden=true;q('[data-add-controls]').hidden=false;state.added=false;state.unknown=false;update();
    let note=q('[data-edit-note]');
    if(!note){
      note=document.createElement('p');note.className='c1-small c1-muted';note.dataset.editNote='';note.setAttribute('role','status');note.tabIndex=-1;
      note.textContent=text('product','editing_keychain','Editing the keychain in your cart. Your changes will replace it.');
      q('.c1-form-step')?.before(note);
    }
    note.focus?.({preventScroll:true});note.scrollIntoView?.({block:'center'});
  };
  {
    // Post-add controls: [Edit this keychain] [Continue to checkout], then "Add another" and "View cart".
    const another=q('[data-another]'),edit=document.createElement('button'),links=document.createElement('div'),viewCart=q('[data-added] [data-cart-open]');
    edit.type='button';edit.className='c1-pill';edit.dataset.editLine='';edit.textContent=text('product','edit_keychain','Edit this keychain');
    edit.addEventListener('click',editLine);
    another.before(edit);
    another.textContent=text('product','add_another','Add another');another.className='c1-link';another.style.cssText='border:0;background:none;padding:0;text-decoration:underline';
    links.className='c1-row';links.style.cssText='justify-content:center;gap:24px';
    if(viewCart)viewCart.before(links);else q('[data-added]').append(links);
    links.append(another);if(viewCart)links.append(viewCart);
  }
  // The delivery sheet resolves Close and its summary Edit the same way, so note which one it was.
  document.addEventListener('click',event=>{if(state.sending&&event.target.closest?.('.c1-delivery__summary-edit'))state.sheetEdit=true;},true);
  // Remove exactly the line this page added (its key from the cart/add.js response), and only while
  // it is still that line and no checkout for this cart is held. Any doubt: nothing is added.
  const replaceLine=async(line,payload,submitted)=>{
    const refuse=message=>Object.assign(new Error(message),{confirmedFailure:true});
    const failed=text('product','edit_cart_failed','We couldn’t update the keychain in your cart, so nothing was added. Please try again.');
    try{await cartPending;}catch{}
    let cart,after;
    try{cart=await request('cart.js');}catch{throw refuse(failed);}
    const mine=(cart.items||[]).filter(item=>item.properties?._c1_line_request===line.request),current=mine.find(item=>item.key===line.key);
    if(mine.length>(current?1:0))throw refuse(failed);
    if(current){
      if(checkoutHeld())throw Object.assign(refuse(text('product','edit_checkout_held','This keychain is already in a checkout, so we can’t change it here.')),{held:true});
      // A quantity changed in the cart is kept, unless the shopper changed it on this page.
      if(current.quantity!==line.qty&&submitted.qty===line.qty){state.qty=submitted.qty=current.quantity;submitted.total=money(submitted.unit*current.quantity);payload.set('quantity',String(current.quantity));}
      try{after=await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});}catch{throw refuse(failed);}
      if(!Array.isArray(after?.items)||after.items.some(item=>item.key===line.key))throw refuse(failed);
    }
    // The earlier line is gone (or was already removed): a retry adds, never removes again.
    state.replace=undefined;q('[data-edit-note]')?.remove();
  };
  const revealRequiredField = field => {
    field.focus({preventScroll:true});
    const step = field.closest?.('.c1-form-step') || field;
    step.scrollIntoView?.({block:'center',behavior:'auto'});
  };
  q('[data-next-step]')?.addEventListener('click',()=>{
    const missing=nextMissing();
    if(!missing)return;
    const html=document.documentElement, behavior=html.style.scrollBehavior;
    html.style.scrollBehavior='auto';
    revealRequiredField(missing.field);
    html.style.scrollBehavior=behavior;
  });
  q('[data-course]')?.addEventListener('input',()=>update());
  // A lost add response is not permission to add again. For string-only
  // personalization, one read can prove this exact request already landed.
  // Cart photo URLs cannot prove the original file bytes, so file uploads hold.
  const reconcileAdded = async (payload, submitted, lineRequest) => {
    const expected = new Map();
    try {
      for (const [name, value] of payload.entries()) {
        const property = /^properties\[(.+)\]$/.exec(name);
        if (!property) continue;
        if (typeof value !== 'string' || expected.has(property[1])) return null;
        expected.set(property[1], value);
      }
    } catch { return null; }
    if (expected.get('_c1_line_request') !== lineRequest) return null;
    let cart;
    try { cart = await request('cart.js'); } catch { return null; }
    if (!Array.isArray(cart?.items)) return null;
    const matches = cart.items.filter(item => item?.properties?._c1_line_request === lineRequest);
    if (matches.length !== 1) return null;
    const item = matches[0], properties = item.properties;
    if (typeof item.key !== 'string' || !item.key || String(item.variant_id || item.id) !== submitted.variantId || Number(item.quantity) !== submitted.qty ||
        !properties || Array.isArray(properties) || Object.keys(properties).length !== expected.size ||
        [...expected].some(([key, value]) => properties[key] !== value)) return null;
    return item;
  };
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(state.sending||state.unknown||state.added||checkoutPending)return;
    const intent=event.submitter?.dataset.purchaseIntent || 'checkout';
    const error=q('[data-product-error]');
    const photoNeeded=!q('[data-photo-step]').hidden;
    const wordsNeeded=!q('[data-words-step]').hidden;
    const replace=state.replace;
    if(photoNeeded&&!q('[data-photo]').files.length){error.textContent=replace?.photo?text('product','edit_photo_again','Add the photo again to update this keychain.'):text('product','no_photo');error.hidden=false;revealRequiredField(q('[data-photo]'));return;}
    if(wordsNeeded&&!q('[data-words]').value.trim()){error.textContent=text('product','no_words');error.hidden=false;revealRequiredField(q('[data-words]'));return;}
    if(Number(entry.words_limit)>0&&[...q('[data-words]').value].length>Number(entry.words_limit)){error.textContent='Shorten the words to fit the confirmed limit.';error.hidden=false;return;}
    if(!selected||selected.available===false){error.textContent=text('product','unavailable');error.hidden=false;return;}
    state.sending=true;state.sheetEdit=false;error.hidden=true;update();
    const payload=new FormData(form);
    payload.delete('engraving');payload.delete('people');payload.delete('name_option');
    // An edit keeps the replaced line's private request id.
    const lineRequest=replace?.request||crypto.randomUUID();
    payload.set('properties[_c1_line_request]',lineRequest);
    const submitted={title:entry.meta.title,variantTitle:selected.title,variantId:String(selected.id),qty:state.qty,unit:selected.price,total:q('[data-total-price]')?.textContent.trim()||'',words:q('[data-words]').value,wordsNeeded,preview:q('[data-preview-request] input').checked};
    // Buy now only: one plain-text line for the delivery sheet, at most 120 characters, e.g.
    // Beech keychain, round · Custom text only · “Mama Lyn” · ₱68 (long words are shortened, never the price).
    // Built after an edit's removal, so a quantity kept from the cart shows.
    const summarize=()=>{
      if(intent!=='checkout')return;
      const head=[`${submitted.qty>1?`${submitted.qty} × `:''}${submitted.title}`,submitted.variantTitle==='Default Title'?'':submitted.variantTitle].filter(Boolean).join(' · ');
      const price=submitted.total, room=120-head.length-price.length-9;
      let words=submitted.wordsNeeded?submitted.words.trim():'';
      if(words.length>room){let cut='';for(const ch of words){if(cut.length+ch.length>room-1)break;cut+=ch;}words=`${cut}…`;}
      return {text:[head,words&&`“${words}”`,price].filter(Boolean).join(' · ').slice(0,120)};
    };
    try {
      // Load public address lists while the required original photo uploads.
      // No customer details or cart mutations are sent by this optional preload.
      if (intent==='checkout' && typeof window.C1Delivery?.preload === 'function') {
        try { Promise.resolve(window.C1Delivery.preload()).catch(() => {}); } catch {}
      }
      // Edit mode only: remove the earlier line BEFORE any sheet opens, so a refused or failed
      // removal ends here on the page with nothing added. The add barrier below still covers it.
      const removal=replace&&replaceLine(replace,payload,submitted);
      const addReady=(async()=>{
        if(removal)await removal;
        let added;
        try {
          added=await request('cart/add.js',{method:'POST',body:payload});
          if(String(added?.variant_id||added?.id)!==submitted.variantId||Number(added?.quantity)!==submitted.qty)throw new Error(text('product','unknown'));
        } catch(e) {
          if(replace&&e.confirmedFailure)e.message+=text('product','edit_removed_notice',' Your earlier keychain is no longer in your cart.');
          if(e.confirmedFailure)throw e;
          added=await reconcileAdded(payload,submitted,lineRequest);
          if(!added)throw e;
        }
        state.added=true;
        rememberCompare(selected.id, selected.compare_at_price > selected.price ? selected.compare_at_price : 0);
        state.line={key:added.key,request:lineRequest,qty:submitted.qty,photo:photoNeeded};
        try{localStorage.removeItem(choicesKey(entry.product.handle));}catch{}
        q('[data-choices-note]')?.remove();
        q('[data-added-summary]').textContent=`${added.quantity} × ${submitted.title} · ${submitted.variantTitle}${submitted.wordsNeeded?' · “'+submitted.words+'”':''}${submitted.preview?' · preview requested':''}`;
        q('[data-added]').hidden=false;q('[data-add-controls]').hidden=true;
        // A shopper may open the cart while this save finishes. Refresh only
        // that existing view; never reopen a cancelled flow or delay delivery.
        if ($('#c1-cart')?.open || cartPage) refreshCart().catch(()=>{});
      })();
      productAddPending=addReady;
      addReady.then(()=>{
        if(productAddPending===addReady)productAddPending=undefined;
      },error=>{
        // Keep an ambiguous mutation held across all checkout entry points.
        if(error.confirmedFailure&&productAddPending===addReady)productAddPending=undefined;
      });
      if(removal)await removal;
      const summary=summarize();
      if(intent==='checkout' && window.C1Delivery?.cartReadyVersion===1) {
        const deliveryReady=finishCheckout(true,addReady,summary);
        await addReady;
        await deliveryReady;
      } else {
        await addReady;
        if(intent==='checkout') await finishCheckout(true,undefined,summary);
        else await openCart();
      }
    } catch(e){
      state.unknown=!e.confirmedFailure;error.textContent=state.unknown?text('product','unknown'):e.message;error.hidden=false;
      // A checkout holds that line: leave edit mode (the line stays as it is) and point to Messenger.
      if(e.held){
        state.replace=undefined;q('[data-edit-note]')?.remove();
        state.added=true;q('[data-added]').hidden=false;q('[data-add-controls]').hidden=true;
        const link=document.createElement('a');link.href='https://m.me/carryone.creations';link.target='_blank';link.rel='noopener noreferrer';link.textContent=text('product','messenger_help_action','message us on Messenger');
        error.append(text('product','edit_messenger_lead',' To change it, '),link,'.');
      }
    }
    finally{
      state.sending=false;update();
      if(state.sheetEdit){state.sheetEdit=false;if(state.added)editLine();}
    }
  });
  const requested=entry.product.variants.find(v=>String(v.id)===qs.get('variant'));
  if(requested&&entry.meta.kind==='wood')state.engraving=/text.*image|image.*text/i.test(requested.title)?'both':/text only/i.test(requested.title)?'text':'photo';
  if(requested&&entry.meta.kind==='chibi') {
    state.people=/3\+/.test(requested.title)?'large':'small';
    state.names=/without/i.test(requested.title)?'without':'with';
    qa('input[name=people]').forEach(input=>{input.checked=input.value===state.people;});
    qa('input[name=name_option]').forEach(input=>{input.checked=input.value===state.names;});
  }
  if(entry.meta.kind==='graduation')q('[data-grad-variant]').value=String((requested||entry.product.variants.find(v=>v.available!==false)||entry.product.variants[0]).id);
  // Keep the shopper's choices (options and typed words, never the photo) for 48 hours per
  // product; cleared after a successful add. A browser cannot restore a chosen file, so the
  // photo step stays required. Options in the URL (ad or shared links) win over saved ones.
  // Quantity is never kept: phones hide the stepper, and an ad link must open at its price.
  const choicesKey = handle => `c1-choices:${handle}`;
  const saveChoices = () => {
    try { localStorage.setItem(choicesKey(entry.product.handle), JSON.stringify({ id: entry.product.id, handle: entry.product.handle, at: Date.now(), engraving: state.engraving, people: state.people, names: state.names, grad: q('[data-grad-variant]')?.value || '', words: q('[data-words]').value, course: q('[data-course]')?.value || '' })); } catch {}
  };
  form.addEventListener('input', saveChoices);
  form.addEventListener('change', saveChoices);
  form.addEventListener('click', event => { if (event.target.closest?.('[data-wood-choice]')) saveChoices(); });
  try {
    const saved = JSON.parse(localStorage.getItem(choicesKey(entry.product.handle)) || 'null');
    if (saved && (saved.id !== entry.product.id || saved.handle !== entry.product.handle || !(Date.now() - saved.at < 48 * 36e5))) localStorage.removeItem(choicesKey(entry.product.handle));
    else if (saved) {
      const linked = qs.has('engraving') || qs.has('variant');
      const snapshot = () => JSON.stringify([state.engraving, state.people, state.names, q('[data-grad-variant]')?.value, q('[data-words]').value, q('[data-course]')?.value]);
      const before = snapshot();
      if (!linked && entry.meta.kind === 'wood' && ['text', 'photo', 'both'].includes(saved.engraving)) state.engraving = saved.engraving;
      if (!linked && entry.meta.kind === 'chibi') {
        if (['small', 'large'].includes(saved.people)) state.people = saved.people;
        if (['with', 'without'].includes(saved.names)) state.names = saved.names;
        qa('input[name=people]').forEach(input => { input.checked = input.value === state.people; });
        qa('input[name=name_option]').forEach(input => { input.checked = input.value === state.names; });
      }
      if (!linked && entry.meta.kind === 'graduation' && entry.product.variants.some(v => String(v.id) === saved.grad && v.available !== false)) q('[data-grad-variant]').value = saved.grad;
      if (typeof saved.words === 'string' && !q('[data-words]').value) q('[data-words]').value = saved.words;
      if (typeof saved.course === 'string' && q('[data-course]') && !q('[data-course]').value) q('[data-course]').value = saved.course;
      if (snapshot() !== before) {
        const note = document.createElement('p');
        note.className = 'c1-small c1-muted';
        note.dataset.choicesNote = '';
        note.setAttribute('role', 'status');
        note.textContent = text('product','choices_kept','We kept your choices.');
        q('.c1-form-step')?.before(note);
      }
    }
  } catch {}
  update(true);
  document.fonts?.ready.then(fitEngravedWords).catch(() => {});
  if(entry.meta.kind==='wood')Promise.all(products.filter(x=>x.meta.kind==='wood').map(async x=>{try{const live=await request(`products/${x.product.handle}.js`);x.product=live;}catch{}})).then(()=>update(true));
})();
